import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'

const HealthStatusServiceTTHAProxy = ({ data, env }) => {
    const tab_col = [
        {
            field: "fix_session",
            headerName: "FIX Session",
            minWidth: 150,
            suppressSizeToFit: true,
        },
    ]

    const tab_col2 = [
        {
            field: "fix_session",
            headerName: "FIX Session",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "server",
            headerName: "Server",
            minWidth: 280,
            suppressSizeToFit: true,
        },
        {
            field: "backend",
            headerName: "Backend",
            minWidth: 180,
            suppressSizeToFit: true,
        },
    ]

    const [tab_data, settab_data] = useState([])
    useEffect(() => {
        let tab_data_temp = []
        if (data.blocked_fix_sessions) {
            tab_data_temp = data.blocked_fix_sessions.reduce((rowData, fix_session) => {
                rowData.push({
                    uniqueId: fix_session,
                    fix_session: fix_session
                })
                return rowData
            }, [])
        }
        settab_data(tab_data_temp)
    }, [data.blocked_fix_sessions])

    const [tab_data2, settab_data2] = useState([])

    useEffect(() => {
        let tab_data2_temp = []
        if (data.backends) {

            tab_data2_temp = data.backends.reduce((rowData, row) => {
                rowData.push({
                    uniqueId: row.fix_session,
                    fix_session: row.fix_session,
                    backend: row.backend,
                    server: row.server
                })
                return rowData
            }, [])
        }
        settab_data2(tab_data2_temp)
    }, [data.backends])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            {tab_data.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Blocked FIX Sessions</Text>
                    <AgDataTable
                        tab_col={tab_col}
                        tab_data={tab_data}
                        tableName="HealthStatusServiceTTHAProxyBlocked"
                        tableHeight={700}
                    />
                </>
            }

            {tab_data2.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }}
                        size="small" color="dark-3" weight="bold">Redirected FIX Sessions</Text>
                    <AgDataTable
                        tab_col={tab_col2}
                        tab_data={tab_data2}
                        tableName="HealthStatusServiceTTHAProxyBackend"
                        tableHeight={700}
                    />
                </>
            }
        </Box>
    )
}

export default HealthStatusServiceTTHAProxy